import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip'

const SearchFormFiltersBookableNowOnly = ({ show_bookable_now_only, submitRef, submitOnChange }) => {
    const [val, setVal] = useState(show_bookable_now_only ? "true" : "");

    useEffect(() => {
        if (val !== show_bookable_now_only && submitOnChange)
            submitRef.current.click();
    }, [val]);

    return (
        <span className="button-title filtering-btn" data-tip="Only show RVs that are able to be booked immediately (auto-accepted by the host).">
            <Form.Control name="show_bookable_now_only" value={val ? val : ""} onChange={(e) => { }} style={{ display: 'none' }} />
            <button
                type="button"
                className="btn btn-mod btn-border btn-circle btn-custom-mod"
                style={{
                    width: "100%",
                    backgroundColor: val && "#71b46a",
                    color: val ? "white" : "#71b46a"
                }}
                onClick={(e) => {
                    setVal(val ? "" : "true");
                }}>
                Book Now
            </button>
            <ReactTooltip />
        </span>
    );
}

export default SearchFormFiltersBookableNowOnly;